<template>
  <hm-content title="">
    <div class="table-panel flex flex-start mb20">
      <div>
        商品筛选：
        <el-cascader
          v-model="searchCondition.categoryId"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="categoryFunc"
          clearable
          placeholder="请选择商品类别"
        ></el-cascader>
        <el-select
          filterable
          clearable
          style="width:200px"
          size="small"
          v-model="searchCondition.brandId"
          placeholder="请选择商品品牌"
        >
          <el-option label="全部" value="all"></el-option>
          <el-option
            :label="v.brandName"
            :value="v.brandId"
            v-for="(v, i) in allBrandList.records"
            :key="i"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="table-panel flex flex-wrap mb20">
      <div>
        时间对比模式:
      </div>
      <el-radio-group
        v-model="searchCondition.compareType"
        class="margin-right ml10"
        size="small"
      >
        <el-radio label="">不对比</el-radio>
        <el-radio label="month">月对比</el-radio>
        <el-radio label="year">年对比</el-radio>
      </el-radio-group>
    </div>
    <div
      class="table-panel flex flex-wrap mb20"
      v-if="searchCondition.compareType === 'month'"
    >
      <div class="flex item-center">
        时间对比时段:
      </div>
      <!-- <el-date-picker
        v-model="searchCondition.applyDate"
        type="monthrange"
        align="right"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        size="small"
        class="ml20"
        style="width:300px"
        clearable
      ></el-date-picker> -->
      <el-select
        filterable
        clearable
        class="ml10"
        style="width:200px"
        size="small"
        multiple
        v-model="searchCondition.monthList"
        placeholder="请选择月份"
      >
        <el-option label="01" value="01"></el-option>
        <el-option label="02" value="02"></el-option>
        <el-option label="03" value="03"></el-option>
        <el-option label="04" value="04"></el-option>
        <el-option label="05" value="05"></el-option>
        <el-option label="06" value="06"></el-option>
        <el-option label="07" value="07"></el-option>
        <el-option label="08" value="08"></el-option>
        <el-option label="09" value="09"></el-option>
        <el-option label="10" value="10"></el-option>
        <el-option label="11" value="11"></el-option>
        <el-option label="12" value="12"></el-option>
      </el-select>
    </div>
    <div class="table-panel flex flex-wrap mb20">
      <div class="flex item-center">
        统计时段：
      </div>
      <!-- <el-date-picker
        v-show="searchCondition.compareType === 'month'"
        v-model="searchCondition.yearDate"
        type="year"
        align="right"
        placeholder="开始年份"
        size="small"
        class="ml20"
        style="width:170px"
        clearable
      ></el-date-picker>
      <span
        class="flex flex-center item-center"
        v-if="searchCondition.compareType === 'month'"
        >--</span
      >
      <el-date-picker
        v-show="searchCondition.compareType === 'month'"
        v-model="searchCondition.endDate"
        type="year"
        align="right"
        placeholder="结束年份"
        size="small"
        style="width:170px"
        clearable
      ></el-date-picker> -->
      <!-- <el-date-picker
        v-if="searchCondition.compareType === 'month'"
        v-model="searchCondition.applyDate"
        type="monthrange"
        align="right"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        size="small"
        class="ml20"
        style="width:350px"
        clearable
      ></el-date-picker> -->

      <el-date-picker
        v-show="searchCondition.compareType !== ''"
        v-model="searchCondition.yearStartDate"
        type="year"
        align="right"
        placeholder="开始年份"
        size="small"
        class="ml20"
        style="width:170px"
        clearable
      ></el-date-picker>
      <span
        class="flex flex-center item-center"
        v-if="searchCondition.compareType !== ''"
        >--</span
      >
      <el-date-picker
        v-show="searchCondition.compareType !== ''"
        v-model="searchCondition.yearEndDate"
        type="year"
        align="right"
        placeholder="结束年份"
        size="small"
        style="width:170px"
        clearable
      ></el-date-picker>
      <el-date-picker
        v-if="searchCondition.compareType === ''"
        v-model="searchCondition.applyDate"
        type="datetimerange"
        align="right"
        :default-time="['00:00:00', '23:59:59']"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        size="small"
        class="ml20"
        style="width:350px"
        clearable
      ></el-date-picker>
    </div>
    <div class="flex flex-between mb20">
      <el-button type="primary" size="small" @click="search"
        >生成报表</el-button
      >
      <el-button
        type="success"
        size="small"
        @click="output"
        :loading="isOutputing"
        >导出</el-button
      >
    </div>
    <div class="table">
      <el-table
        ref="table"
        :data="reportGoodsList.records"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          v-if="searchCondition.compareType"
          header-align="center"
          align="center"
          prop="compareTime"
          label="对比时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandName"
          label="商品品牌"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="商品类别"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="buyNum"
          label="购买人数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderNum"
          label="订单数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="saleNum"
          label="售卖件数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="saleMoney"
          label="销售金额"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="reportGoodsList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                res.result.unshift({
                  value: "all",
                  label: "全部"
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      searchCondition: {
        brandId: "",
        categoryId: [],
        compareType: ""
      },
      currentPage: 1,
      pageSize: 10,
      isOutputing: false
    };
  },
  computed: mapGetters(["reportGoodsList", "allBrandList"]),
  watch: {},
  created() {
    this.getParamsCookie();
    this.$store.dispatch("queryBrandAllList", { pageSize: 999999, pageNo: 1 });
  },
  mounted() {
    this.queryList();
  },
  methods: {
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.setParamsCookie();
      searchCondition.categoryId = searchCondition.categoryId.length
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : "all";
      searchCondition.brandId = searchCondition.brandId
        ? searchCondition.brandId
        : "all";
      searchCondition.startDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.startYear = searchCondition.yearStartDate
        ? moment(searchCondition.yearStartDate).format("YYYY")
        : "";
      searchCondition.endYear = searchCondition.yearEndDate
        ? moment(searchCondition.yearEndDate).format("YYYY")
        : "";
      Object.assign(params, searchCondition);

      return this.$store.dispatch("queryReportGoodsList", params);
    },
    setParamsCookie() {
      setCookie({
        key: "goodsReportListParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "goodsReportListParams",
        type: "session"
      });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryAllList() {
      let params = {
        pageSize: 999999,
        pageNo: 1
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.categoryId = searchCondition.categoryId.length
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : "all";
      searchCondition.brandId = searchCondition.brandId
        ? searchCondition.brandId
        : "all";
      searchCondition.startDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.startYear = searchCondition.yearStartDate
        ? moment(searchCondition.yearStartDate).format("YYYY")
        : "";
      searchCondition.endYear = searchCondition.yearEndDate
        ? moment(searchCondition.yearEndDate).format("YYYY")
        : "";
      Object.assign(params, searchCondition);

      return this.$store.dispatch("queryAllReportGoodsList", params);
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(res => {
            const list = res.result.records;
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            let title = "商品报表";

            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
